(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-drawer-recommendations')) {
    customElements.define(
      'cart-drawer-recommendations',
      class CartDrawerRecommendations extends HTMLElement {
        constructor() {
          super();
          this.intent = this.dataset.intent || 'related';
          this.strategy = this.dataset.strategy || 'last_added';
          this.limit = parseInt(this.dataset.limit) || 4;
          this.abortController = null;
          this.currentProductId = null;
        }

        connectedCallback() {
          // Listen for cart updates
          document.addEventListener('cart:updated', this.handleCartUpdate.bind(this));

          // Load initial recommendations
          this.loadRecommendations();
        }

        disconnectedCallback() {
          document.removeEventListener('cart:updated', this.handleCartUpdate.bind(this));
          if (this.abortController) {
            this.abortController.abort();
          }
          // Destroy swiper instance
          if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }
        }

        handleCartUpdate() {
          this.loadRecommendations();
        }

        async loadRecommendations() {
          // Get cart items
          const cart = await this.getCart();

          if (!cart || !cart.items || cart.items.length === 0) {
            this.innerHTML = '';
            this.currentProductId = null;
            return;
          }

          // Pick the best product from cart to base recommendations on
          const selectedProduct = this.selectProductFromCart(cart.items);

          if (!selectedProduct) {
            this.innerHTML = '';
            this.currentProductId = null;
            return;
          }

          // Only fetch if product changed (avoid unnecessary requests)
          if (selectedProduct.product_id === this.currentProductId) {
            return;
          }

          this.currentProductId = selectedProduct.product_id;

          // Fetch recommendations using cart template
          await this.fetchRecommendationsSection(selectedProduct.product_id);
        }

        async getCart() {
          try {
            const response = await fetch('/cart.js');
            return await response.json();
          } catch (error) {
            console.error('Error fetching cart:', error);
            return null;
          }
        }

        selectProductFromCart(items) {
          // Strategy: Pick the most expensive item (highest price * quantity)
          // This tends to be the main product, accessories are usually cheaper
          if (!items || items.length === 0) return null;

          if (this.strategy == 'last_added') {
            // Return the last item in the array (most recently added)
            return items[items.length - 1];
          }
          else {
            return items.reduce((selected, item) => {
              const currentValue = item.price * item.quantity;
              const selectedValue = selected ? selected.price * selected.quantity : 0;
              return currentValue > selectedValue ? item : selected;
            }, null);
          }
        }

        async fetchRecommendationsSection(productId) {
          // Cancel any pending request
          if (this.abortController) {
            this.abortController.abort();
          }

          this.abortController = new AbortController();

          try {
            // Use Shopify's recommendations endpoint with section rendering
            // This is the SAME approach as related-products section
            const url = `/recommendations/products?product_id=${productId}&section_id=cart-drawer-recommendations&limit=${this.limit}&intent=${this.intent}`;

            const response = await fetch(url, { signal: this.abortController.signal });

            if (!response.ok) {
              throw new Error('Failed to fetch recommendations');
            }

            const responseText = await response.text();
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = responseText;

            // Extract the section wrapper element (same as product-recommendations)
            const sectionWrapper = tempDiv.querySelector(
              'cart-drawer-recommendations-section .cart-drawer-recommendations'
            );

            if (sectionWrapper?.innerHTML.trim().length) {
              // Replace with server-rendered content
              this.innerHTML = sectionWrapper.innerHTML;

              // Initialize Yotpo widgets if available
              if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
                window.yotpoWidgetsContainer.initWidgets(false);
              }

              // Initialize interactive elements (quick-add, swatches)
              this.initializeInteractiveElements();
            } else {
              // No recommendations found
              this.innerHTML = '';
            }
          } catch (error) {
            if (error.name !== 'AbortError') {
              console.error('Error fetching recommendations:', error);
              this.innerHTML = '';
            }
          }
        }

        initializeInteractiveElements() {
          // Quick-add buttons are handled automatically by modal-opener custom elements
          // No additional initialization needed

          // Initialize Swiper slider
          this.initializeSwiper();
          this.classList.add('initialized');
          // Initialize color swatches (if they exist from card-product snippet)
          const swatchGroups = this.querySelectorAll('.card__swatches, .o-swatches__swatch-options');
          swatchGroups.forEach((group) => {
            const buttons = group.querySelectorAll('[data-colour-swatch-button]');
            if (buttons.length > 0) {
              // Set first swatch as active
              buttons[0].classList.add('active');

              // Add event listeners if not already added
              buttons.forEach((button) => {
                if (!button.dataset.listenerAdded) {
                  button.addEventListener('click', this.handleSwatchClick.bind(this));
                  button.addEventListener('mouseenter', this.handleSwatchClick.bind(this));
                  button.dataset.listenerAdded = 'true';
                }
              });
            }
          });
        }

        initializeSwiper() {
          // Destroy existing swiper if it exists
          if (this.swiper) {
            this.swiper.destroy(true, true);
          }

          // Initialize new swiper
          const swiperContainer = this.querySelector('.cart-drawer-recommendations__swiper');
          if (swiperContainer && typeof Swiper !== 'undefined') {
            this.swiper = new Swiper(swiperContainer, {
              slidesPerView: 1,
              spaceBetween: 10,
              mousewheel: {
                forceToAxis: true,
              },
              breakpoints: {
                430: {
                  slidesPerView: 1.1,
                },
                452: {
                  slidesPerView: 1.2,
                }
              },
              navigation: {
                nextEl: '.cart-drawer-recommendations__nav-next',
                prevEl: '.cart-drawer-recommendations__nav-prev',
              },
            });
          }
        }

        handleSwatchClick(event) {
          const button = event.currentTarget;
          const group = button.closest('.card__swatches, .o-swatches__swatch-options');
          if (!group) return;

          // Remove active from all buttons in group
          group.querySelectorAll('[data-colour-swatch-button]').forEach((b) => b.classList.remove('active'));

          // Add active to clicked button
          button.classList.add('active');

          // Update product image
          const card = button.closest('.product-card-wrapper, .card');
          if (!card) return;

          const img = card.querySelector('img');
          if (img) {
            if (button.dataset.varsrcset) {
              img.srcset = button.dataset.varsrcset;
            }
            if (button.dataset.varimage) {
              img.src = button.dataset.varimage;
            }
          }

          // Update quick-add button URL with selected variant
          const quickAddButton = card.querySelector('[data-product-url]');
          if (quickAddButton && button.dataset.variantUrl) {
            quickAddButton.setAttribute('data-product-url', button.dataset.variantUrl);
          }

          // Update mobile link URL with selected variant
          const swiperSlide = card.closest('.swiper-slide');
          const mobileLink = swiperSlide ? swiperSlide.querySelector('.quick-add__mobile-link') : null;
          if (mobileLink && button.dataset.variantUrl) {
            mobileLink.href = button.dataset.variantUrl;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["klaviyo-signup-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('custom-klaviyo-signup-form')) {
    class CustomKlaviyoSignUpForm extends HTMLElement{
        already_registered= "User already registered";
        successfully_registered= "Successfully registered";
        constructor() {
            super();
            this.form = this.querySelector('form');
            this.button = this.querySelector('[data-button]')
            const messagingDiv = this.querySelector('[data-messaging]');
            if (messagingDiv) {
                const messageDivData = JSON.parse(messagingDiv.innerHTML);
                this.already_registered = messageDivData?.already_registered || this.already_registered;
                this.successfully_registered = messageDivData?.successfully_registered || this.successfully_registered;
                messagingDiv.remove();
            }
            this.messageDiv = this.querySelector('[data-signup-message]');
            this.onSubmit = this.onSubmit.bind(this);
            this.form.addEventListener('submit', this.onSubmit);
        }
        onSubmit(e) {
            this.button.innerHTML = "Submitting...";
            e.preventDefault();
            const formData = new FormData(this.form);
            formData.append('$source', '$embed');
            formData.append('$method_id', 'embed');
            // Optionally, do client-side validation, disable button, show loading, etc.
            fetch(this.form.dataset.ajaxSubmit, {
                method: this.form.method,
                body: formData,
                headers: {
                    // fetch auto-sets multipart/form-data etc. If Klaviyo expects JSON or a particular content-type, adjust accordingly.
                }
            })
            .then(async response => {
                    if (response.ok) {
                        const jsonResponse = await response.json();
                        if (jsonResponse.data.is_subscribed) {
                            this.messageDiv.textContent = this.already_registered;
                        } else {
                            this.messageDiv.textContent = this.successfully_registered;
                        }
                        this.form.remove();
                        // success
                        this.form.reset();
                    } else {
                        return response.text().then(text => {
                        // show error
                            this.messageDiv.textContent = (response && response.message) || 'Something went wrong, please try again.';
                            console.error('Error response from Klaviyo:', text);
                        });
                    }
                    this.button.innerHTML = "Sign Up";
                })
                .catch(error => {
                    this.messageDiv.textContent = 'Network error, please try again.';
                    console.error('Network error:', error);
                    this.button.innerHTML = "Sign Up";
                });
        }
    }
    customElements.define('custom-klaviyo-signup-form', CustomKlaviyoSignUpForm);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-sizeguide-modal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-size-guide')) {
  let modalIdCounter = 0;

  customElements.define('product-size-guide', class ProductSizeGuide extends HTMLElement {
    constructor() {
      super();
      this.modalId = `size-guide-modal-${++modalIdCounter}`;
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const trigger = this.querySelector('.size-guide-trigger');
      if (!trigger) return;

      const productTitle = this.dataset.productTitle || '';
      const sizeGuideContent = this.dataset.sizeGuideContent || '';

      // Create modal HTML
      const modalHtml = `
        <div id="${this.modalId}" class="size-guide-modal">
          <div class="modal-content">
            <span class="close">&times;</span>
            <div class="page-content">
              ${sizeGuideContent}
            </div>
          </div>
        </div>
      `;

      const toggleContent = `
        <div class='toggler-parent-wrapper'>
          <div>${productTitle}</div>
          <div class='toggler-btn-wrapper'>
            <div>IN</div>
            <form class="toggle-container">
              <label class="toggle-switch">
                <input type="checkbox" class="toggle-checkbox">
                <span class="slider"></span>
              </label>
            </form>
            <div>CM</div>
          </div>
        </div>
      `;

      // Insert modal into body
      document.body.insertAdjacentHTML('beforeend', modalHtml);

      // Get modal elements
      const modal = document.getElementById(this.modalId);
      const closeBtn = modal.querySelector('.close');
      const pageContent = modal.querySelector('.page-content');
      const table = pageContent?.querySelector('table');

      if (table) {
        const inchElems = pageContent.querySelectorAll('table td imperial');
        const dividerElems = pageContent.querySelectorAll('table td divider');
        const cmElems = pageContent.querySelectorAll('table td metric');

        // Hide dividers and cm by default
        this.toggleVisibility(dividerElems, false);
        this.toggleVisibility(cmElems, false);

        // Wrap table
        const wrapperDivTable = document.createElement('div');
        wrapperDivTable.className = 'toggler-and-table-wrapper';
        table.parentNode.insertBefore(wrapperDivTable, table);
        wrapperDivTable.appendChild(table);

        // Insert toggle content
        table.insertAdjacentHTML('beforebegin', toggleContent);

        // Setup toggle checkbox
        const toggleCheckbox = modal.querySelector('.toggle-checkbox');
        if (toggleCheckbox) {
          toggleCheckbox.addEventListener('change', () => {
            if (toggleCheckbox.checked) {
              this.toggleVisibility(inchElems, false);
              this.toggleVisibility(cmElems, true);
            } else {
              this.toggleVisibility(inchElems, true);
              this.toggleVisibility(cmElems, false);
            }
          });
        }
      }

      // Event listeners
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        modal.style.display = 'block';
      });

      closeBtn.addEventListener('click', () => {
        modal.style.display = 'none';
      });

      window.addEventListener('click', (e) => {
        if (e.target === modal) {
          modal.style.display = 'none';
        }
      });
    }

    disconnectedCallback() {
      // Clean up modal when element is removed
      const modal = document.getElementById(this.modalId);
      if (modal) {
        modal.remove();
      }
    }

    toggleVisibility(elements, show) {
      elements.forEach((element) => {
        if (element) {
          element.style.display = show ? '' : 'none';
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-to-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('scroll-to-button')) {
    class ScrollToButton extends HTMLElement {
        constructor() {
            super();
            this.onClick = this.onClick.bind(this);
            this.addEventListener('click', this.onClick);
        }
        onClick(e) {
            e.preventDefault();
            this.scrollTo = this.dataset.scrollTo;
            if (this.scrollTo !== "") {
                const header = document.querySelector(".section-header");
                const target = document.querySelector(this.scrollTo);

                if (!header || !target) return;

                const headerHeight =(header?.offsetHeight || 0) + (header?.getBoundingClientRect().top || 0);
                const targetPosition = target.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = targetPosition - headerHeight;

                window.scrollTo({
                    behavior: "smooth",
                    top: offsetPosition
                });
            }
        }
    }
    customElements.define('scroll-to-button', ScrollToButton)
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-responsive"] && !Shopify.designMode) return;
  try {
    class LazyVideoResponsive {
    constructor(container) {
      this.container = container;
      this.mobileVideo = container.querySelector('.lazy-video-r[data-device="mobile"]');
      this.desktopVideo = container.querySelector('.lazy-video-r[data-device="desktop"]');
      this.mobilePoster = container.querySelector('.lazy-video-r-poster.mobile-only');
      this.desktopPoster = container.querySelector('.lazy-video-r-poster.desktop-only');
      this.mobilePlayBtn = container.querySelector('.lazy-video-r-play-btn[data-device="mobile"]');
      this.desktopPlayBtn = container.querySelector('.lazy-video-r-play-btn[data-device="desktop"]');
      
      this.hasMobileVideo = this.container.dataset.hasMobileVideo === 'true';
      this.hasDesktopVideo = this.container.dataset.hasDesktopVideo === 'true';
      this.currentDevice = this.getDeviceType();
      this.isLoaded = { mobile: false, desktop: false };
      this.isPlaying = false;
      this.isBuffering = false;
      
      this.init();
    }
    
    init() {
      // Check if component should be visible for current device
      const hasVideoForDevice = (this.currentDevice === 'mobile') ? this.hasMobileVideo : this.hasDesktopVideo;
      
      if (!hasVideoForDevice) {
        if (this.currentDevice === 'mobile' && !this.hasMobileVideo) {
          this.container.style.display = 'none';
        } else if (this.currentDevice === 'desktop' && !this.hasDesktopVideo) {
          this.container.style.display = 'none';
        }
        // Still set up resize listener for device switching
        window.addEventListener('resize', () => this.handleResize());
        return;
      }
      
      // Set up intersection observer for lazy loading
      if ('IntersectionObserver' in window) {
        this.setupIntersectionObserver();
      } else {
        this.loadCurrentVideo();
      }
      
      // Set up play button event handlers
      if (this.mobilePlayBtn) {
        this.mobilePlayBtn.addEventListener('click', () => this.handlePlayClick('mobile'));
        this.mobilePlayBtn.addEventListener('keydown', (e) => this.handleKeyDown(e, 'mobile'));
      }
      
      if (this.desktopPlayBtn) {
        this.desktopPlayBtn.addEventListener('click', () => this.handlePlayClick('desktop'));
        this.desktopPlayBtn.addEventListener('keydown', (e) => this.handleKeyDown(e, 'desktop'));
      }
      
      // Set up resize listener for device switching
      window.addEventListener('resize', () => this.handleResize());
      
      // Load responsive images
      this.loadResponsiveImages();
    }
    
    getDeviceType() {
      return window.innerWidth <= 767 ? 'mobile' : 'desktop';
    }
    
    getCurrentVideo() {
      if (this.currentDevice === 'mobile' && this.hasMobileVideo) {
        return this.mobileVideo;
      } else if (this.currentDevice === 'desktop' && this.hasDesktopVideo) {
        return this.desktopVideo;
      }
      return null;
    }
    
    getCurrentPlayBtn() {
      if (this.currentDevice === 'mobile' && this.hasMobileVideo) {
        return this.mobilePlayBtn;
      } else if (this.currentDevice === 'desktop' && this.hasDesktopVideo) {
        return this.desktopPlayBtn;
      }
      return null;
    }
    
    setupIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isLoaded[this.currentDevice]) {
            // Only load if video exists for current device
            const hasVideo = (this.currentDevice === 'mobile') ? this.hasMobileVideo : this.hasDesktopVideo;
            if (hasVideo) {
              this.loadCurrentVideo();
              observer.unobserve(this.container);
            }
          }
        });
      }, {
        rootMargin: '50px 0px',
        threshold: 0.1
      });
      
      observer.observe(this.container);
    }
    
    loadResponsiveImages() {
      // Only load images for devices that have videos
      const postersToLoad = [];
      if (this.hasMobileVideo && this.mobilePoster) postersToLoad.push(this.mobilePoster);
      if (this.hasDesktopVideo && this.desktopPoster) postersToLoad.push(this.desktopPoster);
      
      postersToLoad.forEach(poster => {
        if (poster && poster.dataset.srcset) {
          poster.srcset = poster.dataset.srcset;
          poster.sizes = poster.dataset.sizes;
          poster.src = poster.dataset.srcset.split(' ')[0];
        }
      });
    }
    
    async loadCurrentVideo() {
      const device = this.currentDevice;
      if (this.isLoaded[device]) return;
      
      // Check if video exists for current device
      const hasVideo = (device === 'mobile') ? this.hasMobileVideo : this.hasDesktopVideo;
      if (!hasVideo) {
        // Hide container if no video exists for current device
        if ((device === 'mobile' && !this.hasMobileVideo) || (device === 'desktop' && !this.hasDesktopVideo)) {
          this.container.style.display = 'none';
        }
        return;
      }
      
      this.container.classList.add('loading');
      
      try {
        const video = this.getCurrentVideo();
        if (!video) {
          this.container.classList.remove('loading');
          return;
        }
        
        const sourcesData = device === 'mobile' 
          ? this.container.dataset.mobileSources 
          : this.container.dataset.desktopSources;
        
        if (!sourcesData || sourcesData === '[]') {
          this.container.classList.remove('loading');
          return;
        }
        
        const videoSources = JSON.parse(sourcesData);
        const autoplay = this.container.dataset.autoplay === 'true';
        const loop = this.container.dataset.loop === 'true';
        const muted = this.container.dataset.muted === 'true';
        const controls = this.container.dataset.controls === 'true';
        
        // Set video attributes
        if (!this.prefersReducedMotion()) {
          video.autoplay = autoplay;
        } else {
          video.autoplay = false;
        }
        video.loop = loop;
        video.muted = muted;
        video.controls = controls;
        
        // Clear existing sources
        video.innerHTML = '';
        
        // Sort sources by preference (MP4 first, then WebM, then others)
        const sortedSources = videoSources.sort((a, b) => {
          const formatPriority = { 'mp4': 0, 'webm': 1, 'mov': 2 };
          const aPriority = formatPriority[a.format] || 99;
          const bPriority = formatPriority[b.format] || 99;
          
          if (aPriority !== bPriority) {
            return aPriority - bPriority;
          }
          
          // If same format, prefer higher resolution
          return (b.width * b.height) - (a.width * a.height);
        });
        
        // Add source elements
        sortedSources.forEach(source => {
          if (source.url && source.mime_type) {
            const sourceElement = document.createElement('source');
            sourceElement.src = source.url;
            sourceElement.type = source.mime_type;
            video.appendChild(sourceElement);
          }
        });
        
        // Fallback: if no sources work, use the first MP4 as src
        const mp4Source = sortedSources.find(s => s.format === 'mp4');
        if (mp4Source) {
          video.src = mp4Source.url;
        }
        
        // Wait for video metadata to load
        await new Promise((resolve, reject) => {
          video.addEventListener('loadedmetadata', resolve, { once: true });
          video.addEventListener('error', reject, { once: true });
          video.load();
        });
        
        this.isLoaded[device] = true;
        this.container.classList.remove('loading');
        
        // Auto-play if enabled and user hasn't requested reduced motion
        if (autoplay && !this.prefersReducedMotion()) {
          this.play();
        }
        
      } catch (error) {
        console.warn(`Failed to load ${device} video:`, error);
        this.container.classList.remove('loading');
      }
    }
    
    async handleResize() {
      const newDevice = this.getDeviceType();
      
      if (newDevice !== this.currentDevice) {
        // Stop and hide current video
        this.stopAndHideVideo(this.currentDevice);
        
        // Switch to new device
        this.currentDevice = newDevice;
        
        // Check if the new device has a video available
        const hasVideoForDevice = (newDevice === 'mobile') ? this.hasMobileVideo : this.hasDesktopVideo;
        
        if (hasVideoForDevice) {
          // Show container if it was hidden
          this.container.style.display = '';
          
          // Load new video if needed
          if (!this.isLoaded[this.currentDevice]) {
            await this.loadCurrentVideo();
          } else {
            // If video is already loaded, handle autoplay for device switch
            const autoplay = this.container.dataset.autoplay === 'true';
            if (autoplay && !this.prefersReducedMotion()) {
              this.play();
            }
          }
        } else {
          // Hide container based on device and video availability
          if (newDevice === 'mobile' && !this.hasMobileVideo) {
            this.container.style.display = 'none';
          } else if (newDevice === 'desktop' && !this.hasDesktopVideo) {
            this.container.style.display = 'none';
          }
        }
      }
    }
    
    stopAndHideVideo(device) {
      const video = device === 'mobile' ? this.mobileVideo : this.desktopVideo;
      
      if (video) {
        // Always pause and reset video
        if (!video.paused) {
          video.pause();
        }
        video.currentTime = 0;
        
        // Remove sources to stop streaming and prevent memory leaks
        video.innerHTML = '';
        video.removeAttribute('src');
        video.load();
        
        // Mark as not loaded to force reload if needed later
        this.isLoaded[device] = false;
      }
      
      this.isPlaying = false;
      this.isBuffering = false;
      this.container.classList.remove('playing');
      this.updateButtonIcon();
    }
    
    prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    
    handleKeyDown(e, device) {
      if (device !== this.currentDevice) return;
      
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.handlePlayClick(device);
      }
    }
    
    async handlePlayClick(device) {
      if (device !== this.currentDevice) return;
      
      if (!this.isLoaded[this.currentDevice]) {
        await this.loadCurrentVideo();
      }
      
      if (this.isPlaying) {
        this.pause();
      } else {
        this.play();
      }
    }
    
    async play() {
      const video = this.getCurrentVideo();
      if (!video || !this.isLoaded[this.currentDevice]) return;
      
      // Wait for sufficient buffer before playing
      if (!this.hasEnoughBuffer()) {
        this.isBuffering = true;
        this.updateButtonIcon();
        await this.waitForBuffer();
        this.isBuffering = false;
      }
      
      try {
        await video.play();
        this.isPlaying = true;
        this.container.classList.add('playing');
        this.updateButtonIcon();
      } catch (error) {
        console.warn('Failed to play video:', error);
        this.isBuffering = false;
        this.updateButtonIcon();
      }
    }
    
    hasEnoughBuffer() {
      const video = this.getCurrentVideo();
      if (!video) return false;
      
      // Check if video has enough metadata and data
      if (video.readyState < 3) { // HAVE_FUTURE_DATA
        return false;
      }
      
      // Check if we have buffered enough content
      if (video.buffered.length === 0) {
        return false;
      }
      
      const currentTime = video.currentTime;
      const bufferedEnd = video.buffered.end(video.buffered.length - 1);
      const bufferAhead = bufferedEnd - currentTime;
      
      // Require at least 3 seconds of buffer ahead
      return bufferAhead >= 3;
    }
    
    async waitForBuffer() {
      const video = this.getCurrentVideo();
      if (!video) return;
      
      return new Promise((resolve) => {
        const checkBuffer = () => {
          if (this.hasEnoughBuffer()) {
            resolve();
          } else {
            setTimeout(checkBuffer, 100);
          }
        };
        
        const onProgress = () => {
          if (this.hasEnoughBuffer()) {
            video.removeEventListener('progress', onProgress);
            video.removeEventListener('canplaythrough', onCanPlayThrough);
            resolve();
          }
        };
        
        const onCanPlayThrough = () => {
          video.removeEventListener('progress', onProgress);
          video.removeEventListener('canplaythrough', onCanPlayThrough);
          resolve();
        };
        
        video.addEventListener('progress', onProgress);
        video.addEventListener('canplaythrough', onCanPlayThrough);
        
        checkBuffer();
        
        setTimeout(() => {
          video.removeEventListener('progress', onProgress);
          video.removeEventListener('canplaythrough', onCanPlayThrough);
          resolve();
        }, 10000);
      });
    }
    
    pause() {
      const video = this.getCurrentVideo();
      if (!video || !this.isLoaded[this.currentDevice]) return;
      
      video.pause();
      this.isPlaying = false;
      this.isBuffering = false;
      this.container.classList.remove('playing');
      this.updateButtonIcon();
    }
    
    updateButtonIcon() {
      const playBtn = this.getCurrentPlayBtn();
      if (!playBtn) return;
      
      const playIcon = playBtn.querySelector('.play-icon');
      const pauseIcon = playBtn.querySelector('.pause-icon');
      const loadingIcon = playBtn.querySelector('.loading-icon');
      
      // Hide all icons first
      if (playIcon) playIcon.style.display = 'none';
      if (pauseIcon) pauseIcon.style.display = 'none';
      if (loadingIcon) loadingIcon.style.display = 'none';
      
      if (this.isBuffering) {
        if (loadingIcon) loadingIcon.style.display = 'block';
        playBtn.setAttribute('aria-label', 'Loading video');
        playBtn.setAttribute('title', 'Loading video');
        playBtn.setAttribute('aria-pressed', 'false');
        playBtn.disabled = true;
      } else if (this.isPlaying) {
        if (pauseIcon) pauseIcon.style.display = 'block';
        playBtn.setAttribute('aria-label', 'Pause video');
        playBtn.setAttribute('title', 'Pause video');
        playBtn.setAttribute('aria-pressed', 'true');
        playBtn.disabled = false;
      } else {
        if (playIcon) playIcon.style.display = 'block';
        playBtn.setAttribute('aria-label', 'Play video');
        playBtn.setAttribute('title', 'Play video');
        playBtn.setAttribute('aria-pressed', 'false');
        playBtn.disabled = false;
      }
    }
  }
  
  // Initialize responsive lazy videos when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    const lazyVideoContainers = document.querySelectorAll('.lazy-video-r-responsive-container');
    lazyVideoContainers.forEach(container => {
      new LazyVideoResponsive(container);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lazy-video-container')) {
  class LazyVideo extends HTMLElement {
    constructor() {
      super();
      this.container = this;
      this.video = this.querySelector('.lazy-video');
      this.poster = this.querySelector('.lazy-video-poster');
      this.playBtn = this.querySelector('.lazy-video-play-btn');
      this.isLoaded = false;
      this.isPlaying = false;
      this.handlePlayClick = this.handlePlayClick.bind(this);
      
      this.init();
    }
    
    init() {
      // Set up intersection observer for lazy loading
      if ('IntersectionObserver' in window) {
        this.setupIntersectionObserver();
      } else {
        // Fallback for older browsers
        this.loadVideo();
      }
      
      // Set up play button event handlers
      if (this.playBtn) {
        this.playBtn.addEventListener('click', this.handlePlayClick);
        this.playBtn.addEventListener('keydown', (e) => this.handleKeyDown(e));
      }
      
      // Lazy load responsive images
      this.loadResponsiveImage();
    }
    
    setupIntersectionObserver() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !this.isLoaded) {
            this.loadVideo();
            observer.unobserve(this.container);
          }
        });
      }, {
        rootMargin: '50px 0px',
        threshold: 0.1
      });
      
      observer.observe(this.container);
    }
    
    loadResponsiveImage() {
      const poster = this.poster;
      if (poster && poster.dataset.srcset) {
        poster.srcset = poster.dataset.srcset;
        poster.sizes = poster.dataset.sizes;
        poster.src = poster.dataset.srcset.split(' ')[0];
      }
    }
    
    async loadVideo() {
      if (this.isLoaded) return;
      
      this.container.classList.add('loading');
      
      try {
        const videoSources = JSON.parse(this.container.dataset.videoSources);
        const autoplay = this.container.dataset.autoplay === 'true';
        const loop = this.container.dataset.loop === 'true';
        const muted = this.container.dataset.muted === 'true';
        const controls = this.container.dataset.controls === 'true';
        
        // Set video attributes
        if (!this.prefersReducedMotion()) {
          this.video.autoplay = autoplay;
        } else {
          this.video.autoplay = false;
        }
        this.video.loop = loop;
        this.video.muted = muted;
        this.video.controls = controls;
        
        // Clear existing sources
        this.video.innerHTML = '';
        
        // Sort sources by preference (MP4 first, then WebM, then others)
        const sortedSources = videoSources.sort((a, b) => {
          const formatPriority = { 'mp4': 0, 'webm': 1, 'mov': 2 };
          const aPriority = formatPriority[a.format] || 99;
          const bPriority = formatPriority[b.format] || 99;
          
          if (aPriority !== bPriority) {
            return aPriority - bPriority;
          }
          
          // If same format, prefer higher resolution
          return (b.width * b.height) - (a.width * a.height);
        });
        
        // Add source elements
        sortedSources.forEach(source => {
          if (source.url && source.mime_type) {
            const sourceElement = document.createElement('source');
            sourceElement.src = source.url;
            sourceElement.type = source.mime_type;
            this.video.appendChild(sourceElement);
          }
        });
        
        // Fallback: if no sources work, use the first MP4 as src
        const mp4Source = sortedSources.find(s => s.format === 'mp4');
        if (mp4Source) {
          this.video.src = mp4Source.url;
        }
        
        // Wait for video metadata to load
        await new Promise((resolve, reject) => {
          this.video.addEventListener('loadedmetadata', resolve, { once: true });
          this.video.addEventListener('error', reject, { once: true });
          this.video.load();
        });
        
        this.isLoaded = true;
        this.container.classList.remove('loading');
        
        // Auto-play if enabled and user hasn't requested reduced motion
        if (autoplay && !this.prefersReducedMotion()) {
          this.play();
        }
        
      } catch (error) {
        console.warn('Failed to load video:', error);
        this.container.classList.remove('loading');
      }
    }
    
    prefersReducedMotion() {
      // Check if user prefers reduced motion
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    
    handleKeyDown(e) {
      // Handle Enter and Space keys
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.handlePlayClick(e);
      }
    }
    
    async handlePlayClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!this.isLoaded) {
        await this.loadVideo();
      }
      
      if (this.isPlaying) {
        this.pause();
      } else {
        this.play();
      }
    }
    
    async play() {
      if (!this.isLoaded) return;
      
      // Wait for sufficient buffer before playing
      if (!this.hasEnoughBuffer()) {
        await this.waitForBuffer();
      }
      
      try {
        await this.video.play();
        this.isPlaying = true;
        this.container.classList.add('playing');
        this.updateButtonIcon();
      } catch (error) {
        console.warn('Failed to play video:', error);
      }
    }
    
    hasEnoughBuffer() {
      const video = this.video;
      
      // Check if video has enough metadata and data
      if (video.readyState < 3) { // HAVE_FUTURE_DATA
        return false;
      }
      
      // Check if we have buffered enough content
      if (video.buffered.length === 0) {
        return false;
      }
      
      const currentTime = video.currentTime;
      const bufferedEnd = video.buffered.end(video.buffered.length - 1);
      const bufferAhead = bufferedEnd - currentTime;
      
      // Require at least 3 seconds of buffer ahead
      return bufferAhead >= 3;
    }
    
    async waitForBuffer() {
      return new Promise((resolve) => {
        const checkBuffer = () => {
          if (this.hasEnoughBuffer()) {
            resolve();
          } else {
            // Check again after a short delay
            setTimeout(checkBuffer, 100);
          }
        };
        
        // Also resolve if we get these events
        const onProgress = () => {
          if (this.hasEnoughBuffer()) {
            this.video.removeEventListener('progress', onProgress);
            this.video.removeEventListener('canplaythrough', onCanPlayThrough);
            resolve();
          }
        };
        
        const onCanPlayThrough = () => {
          this.video.removeEventListener('progress', onProgress);
          this.video.removeEventListener('canplaythrough', onCanPlayThrough);
          resolve();
        };
        
        this.video.addEventListener('progress', onProgress);
        this.video.addEventListener('canplaythrough', onCanPlayThrough);
        
        // Start checking
        checkBuffer();
        
        // Timeout after 10 seconds to avoid infinite waiting
        setTimeout(() => {
          this.video.removeEventListener('progress', onProgress);
          this.video.removeEventListener('canplaythrough', onCanPlayThrough);
          resolve();
        }, 10000);
      });
    }
    
    pause() {
      if (!this.isLoaded) return;
      
      this.video.pause();
      this.isPlaying = false;
      this.container.classList.remove('playing');
      this.updateButtonIcon();
    }
    
    updateButtonIcon() {
      if (!this.playBtn) return;
      
      if (this.isPlaying) {
        // Show pause icon, hide play icon
        if (this.playIcon) this.playIcon.style.display = 'none';
        if (this.pauseIcon) this.pauseIcon.style.display = 'block';
        this.playBtn.setAttribute('aria-label', 'Pause video');
        this.playBtn.setAttribute('title', 'Pause video');
        this.playBtn.setAttribute('aria-pressed', 'true');
      } else {
        // Show play icon, hide pause icon
        if (this.playIcon) this.playIcon.style.display = 'block';
        if (this.pauseIcon) this.pauseIcon.style.display = 'none';
        this.playBtn.setAttribute('aria-label', 'Play video');
        this.playBtn.setAttribute('title', 'Play video');
        this.playBtn.setAttribute('aria-pressed', 'false');
      }
    }
  }
    customElements.define('lazy-video-container', LazyVideo);
  }
  } catch(e) { console.error(e); }
})();

})();
